import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';

export const getTrainingCertificates = (clause: string) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() +
      `training-cert/training-certification?where=` +
      clause
  );
};

export const deleteTrainingCertificates = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() +
      `training-cert/training-certification/delete`,
    obj,
    { headers }
  );
};
export const addTrainingCertificates = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() +
      `training-cert/training-certification/create`,
    obj,
    { headers }
  );
};
export const editTrainingCertificates = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() +
      `training-cert/training-certification/update`,
    obj,
    { headers }
  );
};
